import axios from "axios";
import toast from "react-hot-toast";

export const FETCH_STUDENTS_REQUEST = "FETCH_STUDENTS_REQUEST";
export const FETCH_STUDENTS_SUCCESS = "FETCH_STUDENTS_SUCCESS";
export const FETCH_STUDENTS_FAILURE = "FETCH_STUDENTS_FAILURE";

export const FETCH_FACULTY_REQUEST = "FETCH_FACULTY_REQUEST";
export const FETCH_FACULTY_SUCCESS = "FETCH_FACULTY_SUCCESS";
export const FETCH_FACULTY_FAILURE = "FETCH_FACULTY_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ---------------- FETCH STUDENTS ----------------
export const fetchStudents = ({ page = 1, limit = 10, full_name = "" } = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_STUDENTS_REQUEST });
    const token = localStorage.getItem("token");

    const queryParams = new URLSearchParams({ page, limit, full_name }).toString();

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/admin/students?${queryParams}`, {
        headers: { authorization: token },
      });

      dispatch({
        type: FETCH_STUDENTS_SUCCESS,
        payload: {
          students: response.data.data,
          pagination: response.data.meta.pagination || {},
        },
      });
    } catch (error) {
      let message = "Failed to fetch students";
      if (error?.response?.data?.meta?.message) message = error.response.data.meta.message;
      else if (error?.response?.data?.message) message = error.response.data.message;
      else if (error.message) message = error.message;

      dispatch({ type: FETCH_STUDENTS_FAILURE, payload: message });
      toast.error(message);
    }
  };
};

// ---------------- FETCH FACULTY ----------------
export const fetchFaculty = ({ page = 1, limit = 10, faculty_name = "" } = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_FACULTY_REQUEST });
    const token = localStorage.getItem("token");

    const queryParams = new URLSearchParams({ page, limit, faculty_name }).toString();

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/admin/faculty?${queryParams}`, {
        headers: { authorization: token },
      });

      dispatch({
        type: FETCH_FACULTY_SUCCESS,
        payload: {
          faculty: response.data.data,
          pagination: response.data.meta.pagination || {},
        },
      });
    } catch (error) {
      let message = "Failed to fetch faculty";
      if (error?.response?.data?.meta?.message) message = error.response.data.meta.message;
      else if (error?.response?.data?.message) message = error.response.data.message;
      else if (error.message) message = error.message;

      dispatch({ type: FETCH_FACULTY_FAILURE, payload: message });
      toast.error(message);
    }
  };
};